import styled, { css } from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const singleCardStyles = css`
  flex: 0 0 33%;
  margin: 0 auto;

  @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
    flex: 0 0 50%;
  }
`;

const defaultStyles = css`
  flex: 0 0 calc(33% - 24px);
  margin: 12px;

  @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
    flex: 0 0 calc(50% - 24px);
  }
`;

const CourtCardWrapper = styled.article.withConfig({
  shouldForwardProp: (prop) => prop !== 'colAmount',
})`
  ${({ colAmount }) => (colAmount === 1 ? singleCardStyles : defaultStyles)}

  box-sizing: border-box;
  overflow: hidden;
  background: ${mainColors.main_color_gradient};
  padding: 12px;
  border: 2px solid ${mainColors.text_color};
  border-radius: 24px;
  text-align: center;
  position: relative;

  &:hover {
    box-shadow: 0px 0px 10px 1px ${mainColors.text_color};
    cursor: pointer;
  }

  @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
    flex: 1 1 100%;
  }

  .card-image {
    width: 100%;
    height: 230px;
    /* object-fit: cover; */

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      height: 200px;
    }
    @media only screen and (max-width: 400px) {
      height: 150px;
    }
  }

  .no-image-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    text-align: center;
    width: 90%;
  }

  .no-image {
  }
`;

export default CourtCardWrapper;
